import gql from "graphql-tag";

export const shopApiFragment = gql`
  fragment ShopApiFragment on ShopApi {
    id
    name
    uri
  }
`;
